// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom'; // ✅ import Link
import '../style/footer.css';
import logo from '../assets/sitelogo.svg';
import appstore from '../assets/gallaxystore.png';
import googleplay from '../assets/appstore.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-start">

          {/* Left Brand Section */}
          <div className="col-md-4 mb-4">
            <div className="brand-section">
              <img src={logo} alt="Logo" className="img-fluid mb-2 footerlogo" />
              <h4 className="brand-tagline">Explore World Marketplace Diversity Gateway to Diverse Vendors</h4>
              <p className="enroll-text">Enrollive 2024.</p>
            </div>
          </div>

          <div className="col-md-1 d-none d-md-block"></div>

          {/* Footer Columns */}
          <div className="col-md-7">
            <div className="row">

              <div className="col-md-3 col-sm-6 mb-4">
                <h5 className="column-title">Platform</h5>
                <ul className='legal-links'>
                  <li><Link to="/signUpForm">SignUpForm</Link></li>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">AboutUs</Link></li>
                  <li><Link to="/product">Product</Link></li>
                  <li><Link to="/vendor">Vendor</Link></li>
                </ul>
              </div>

              <div className="col-md-3 col-sm-6 mb-4">
                <h5 className="column-title">Company</h5>
                <ul className="list-unstyled footer-links">
                  <li><Link to="/basicinformation">BasicInfoForm</Link></li>
                  <li><Link to="/firstlisting">Firstlisting</Link></li>
                  <li><Link to="/sellerprofile">SellerProfile</Link></li>
                  <li><Link to="/socialmedia">Socialmedia</Link></li>
                </ul>
              </div>

              <div className="col-md-3 col-sm-6 mb-4">
                <h5 className="column-title">Resources</h5>
                <ul className="list-unstyled footer-links">
                  <li><Link to="/completesetup">Completesetup</Link></li>
                  <li><Link to="/thankyou">Thankyou</Link></li>
                  <li><Link to="/vendorlistingwithmap">Vendorlisting</Link></li>
                  <li><Link to="/product/2">ProductDetail</Link></li>
                </ul>
              </div>

              <div className="col-md-3 col-sm-6 mb-4">
                <h5 className="column-title">Get the app</h5>
                <ul className="list-unstyled footer-links">
                  <li><a href="#"><img src={appstore} alt="App Store" className="img-fluid sailicon" /></a></li>
                  <li><a href="#"><img src={googleplay} alt="Google Play" className="img-fluid sailicon" /></a></li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className='footertext row'>
            <div className='col-md-7'>
              <p className="mb-2 mb-md-0">© 2024 All rights reserved.</p>
            </div>
            <div className='col-md-5'>
              <div className="legal-links d-flex gap-3">
                <Link to="#" className="text-white text-decoration-none">Terms of Service</Link>
                <Link to="#" className="text-white text-decoration-none">Primary Policy</Link>
                <Link to="#" className="text-white text-decoration-none">Cookies</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
